import Vue from 'vue'
import Router from 'vue-router'
import DonatePage from '@/views/DonatePage'
import IframeDonatePage from '@/views/IframeDonatePage'
import UserForgot from '@/views/auth/UserForgot'
import UserLogin from '@/views/auth/UserLogin'
import UserReset from '@/views/auth/UserReset'
import UserSignup from '@/views/auth/UserSignup'
import store from '@/store'

Vue.use(Router)

/*
function authGuard(to, from, next) {
  if (!store.state.auth.loggedIn) {
    next({ name: 'UserLogin' })
  } else {
    next()
  }
}
*/

const router = new Router({
  mode: 'history',

  scrollBehavior() {
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '/login',
      name: 'UserLogin',
      component: UserLogin
    },
    {
      path: '/signup',
      name: 'UserSignup',
      component: UserSignup
    },
    {
      path: '/forgot',
      name: 'UserForgot',
      component: UserForgot
    },
    {
      path: '/reset/:token',
      name: 'UserReset',
      component: UserReset
    },
    {
      path: '/iframe/:slug?',
      name: 'iframe-embed',
      component: IframeDonatePage
    },
    {
      path: '/:slug?',
      name: 'DonatePage',
      component: DonatePage,
      props: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('setReferrer', document.referrer)
        next()
      }
    },
    {
      path: '/:code/:slug',
      name: 'DonatePage',
      component: DonatePage,
      props: true,
      beforeEnter: (to, from, next) => {
        store.dispatch('setReferrer', document.referrer)
        next()
      }
    }
  ]
})

export default router
